import React from 'react';
import { LucideIcon } from 'lucide-react';

export interface ScheduleImpactCardProps {
  icon: LucideIcon;
  heading: string;
  description: React.ReactNode;
}

export const ScheduleImpactCard = ({
  icon: Icon,
  heading,
  description
}: ScheduleImpactCardProps): React.ReactElement => {
  return (
    <div className="tw-flex tw-items-center tw-gap-3 tw-rounded-3xl tw-border-[1px] tw-border-solid tw-border-border-grey tw-px-4 tw-py-3">
      <div className="tw-flex-shrink-0">
        <Icon className="tw-h-6 tw-w-6 tw-text-content-tertiary" />
      </div>
      <div className="tw-flex tw-flex-col tw-gap-1">
        <div className="tw-text-sm tw-font-medium tw-text-black">{heading}</div>
        <div className="tw-text-xs tw-leading-4 tw-text-primary-grey">{description}</div>
      </div>
    </div>
  );
};
